import { Step } from '../types/types';

export const isPii = (
  leadFieldAssociated: string,
  currentStep?: Step,
  stepName?: string,
): boolean => {
  const leadField = leadFieldAssociated.toLowerCase();
  return Boolean(
    leadField.includes('firstname') ||
      leadField.includes('lastname') ||
      leadField.includes('email') ||
      leadField.includes('phonenumber') ||
      leadField.includes('address') ||
      leadField.includes('password') ||
      currentStep?.title?.includes('Name') ||
      currentStep?.title?.includes('Email') ||
      currentStep?.title?.includes('Phone') ||
      currentStep?.title?.includes('Contact') ||
      currentStep?.title?.includes('Address') ||
      stepName?.toLowerCase().includes('name') ||
      stepName?.toLowerCase().includes('email') ||
      stepName?.toLowerCase().includes('phone') ||
      stepName?.toLowerCase().includes('contact') ||
      stepName?.toLowerCase().includes('address'),
  );
};
